import cx from 'classnames';

import styles from '../../styles/homePage/topFunds.scss';
import FundAvatar from '../common/fundAvatar';
import ActionMenu from '../common/actionMenu';
import { topFundsActions } from '../../constants/actionMenu';

const TopFundList = ({
  fundList,
  startInvestment,
  id,
  handleActionClick,
  handleRowClick,
  title,
}) => {
  return (
    <div className={cx(styles['fund-list'], 'row')}>
      <li className={cx('large-12 columns', styles['list-header'])}>
        <div
          className={cx(
            'large-7 small-8 columns text--xsm',
            styles['fund-box'],
            'font--bold'
          )}
        >
          {title ? title.toUpperCase() : 'FUND'}
        </div>
        <div className="large-5 small-4 columns mobile-p0">
          <div className="row">
            <div className="large-12 small-8 columns text--xsm mobile-only--center font--bold">
              5YR. RTNS
            </div>
          </div>
        </div>
      </li>
      {fundList.map((fundItem) => (
        <li
          key={fundItem.productId}
          className={cx('large-12 columns', styles.fundItem)}
          onClick={() => handleRowClick(fundItem, id)}
        >
          <div className={cx('large-7 small-8 columns', styles['fund-box'])}>
            <FundAvatar
              imageValign="super"
              fundItem={fundItem}
              source={`top-funds-${id}`}
              className={cx(
                'font--dark-grey font--bold text--md',
                styles['title']
              )}
              subTitleClass="text--sm font--normal font--grey"
              width={15}
            />
          </div>
          <div className="large-5 small-4 columns mobile-p0">
            <div className="row lil-flex">
              <div className="large-4 small-8 columns pt10 right-align mobile-only--center">
                <span className="text--md">
                  {!fundItem.fiveYearReturns
                    ? '--'
                    : `${fundItem.fiveYearReturns}%`}
                </span>
              </div>
              <div className="large-4 columns desktop-only mr10">
                <a
                  href="#"
                  className={cx(
                    'font--bold font--md inline-block font--blue',
                    styles['hollow-invest']
                  )}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    startInvestment(fundItem);
                  }}
                >
                  INVEST
                </a>
              </div>
              <div className="large-3 columns small-4 pt10">
                <ActionMenu
                  actions={topFundsActions}
                  handleActionClick={(action) =>
                    handleActionClick(action, fundItem)
                  }
                  itemId={fundItem.productId}
                />
              </div>
            </div>
          </div>
        </li>
      ))}
    </div>
  );
};
export default TopFundList;



// WEBPACK FOOTER //
// ./components/homePage/topFundList.tsx